import tripTypesEnum from '../constants/trip-types-enum';
import latinCharacters from '../constants/latin-characters';
import regexMap from '../constants/regex-map';

/**
 * @param {Shape.storefrontData} storefrontData - storefront data
 * @param {airportsMapUIModel} airportsMapModel
 *
 * @return {Array}
 */
function getPopularDestinations(storefrontData, airportsMapModel) {
  if (!storefrontData || !airportsMapModel) return;

  const popularDestinationCodes = storefrontData.popularDestinations.split(',');
  const popularDestinations = [];

  for (let i = 0; i < popularDestinationCodes.length; i++) {
    const airport = airportsMapModel.getAirportByCode(popularDestinationCodes[i]);
    if (airport) {
      airport.skyteam = false;

      popularDestinations.push(airport);
    }
  }

  return popularDestinations;
}

const bookerIconsMapper = {
  ROUND_TRIP: 'arrowReturnTrip',
  ONE_WAY: 'arrowRight',
  MULTI_DESTINATION: 'arrowMultiTrip',
};

function getTripType(itinerary) {
  let tripType = tripTypesEnum.ONE_WAY;

  if (itinerary.length === 2) {
    tripType = tripTypesEnum.ROUND_TRIP;
  } else if (itinerary.length > 2) {
    tripType = tripTypesEnum.MULTI_DESTINATION;
  }

  return tripType;
}

function serializeUrl(bookerObject, urlMap) {
  const keyValuePairs = [];

  for (const key in bookerObject) {    
    const urlKey = urlMap ? urlMap[key] : key;
    keyValuePairs.push(urlKey + '=' + encodeURIComponent(bookerObject[key]));
  }
  return keyValuePairs.join('&');
}

function normalizeString(string = '') {
  const normalized = string.replace(regexMap.NON_ALPHA_LATIN_CHARACTERS, (match) => {
    return latinCharacters[match];
  }).replace(/\\/g, '');

  return normalized;
}

export {
  bookerIconsMapper,
  getPopularDestinations,
  getTripType,
  normalizeString,
  serializeUrl,
};
